import { LEFT } from 'constants/mouse';
import { Position, GestureNativeEvent } from 'types';
import { calculateDistance } from 'helpers/drag';
import { isTargetElement } from 'helpers/gestures';

const TAPS_COUNT = 2;
const DELAY = 600;
const WIGGLE_THRESHOLD = 30;

let taps = 0;
let timer: number | null = null;
let target: HTMLElement | null = null;
let upEventType: string | null = null;
let downEventType: string | null = null;
let position: Position | null = null;

const onSuccess = () => {
  if (!target) return;

  const event = document.createEvent('Event');
  event.initEvent('doubletap', true, true);
  target.dispatchEvent(event);
};

const reset = () => {
  clearTimeout(timer!);
  timer = null;

  taps = 0;
  target = null;
  position = null;

  upEventType = null;
  downEventType = null;
};

const down = (e: GestureNativeEvent) => {
  if (e.simulated) return;
  if (e.type === 'mousedown' && (e as MouseEvent).button !== LEFT) return;
  if (downEventType !== null && downEventType !== e.type) return;
  if (target !== null && target !== e.target) return;
  if (!isTargetElement(e)) return;

  target = e.target;
  downEventType = e.type;

  clearTimeout(timer!);
  timer = window.setTimeout(reset, DELAY);

  if (taps === 0 && !position) {
    position = {
      x: e.pageX,
      y: e.pageY,
    };
  }
};

const up = (e: GestureNativeEvent) => {
  if (e.simulated) return;
  if (e.type === 'mouseup' && (e as MouseEvent).button !== LEFT) return;
  if (upEventType !== null && upEventType !== e.type) return;
  if (target !== null && target !== e.target) return;
  if (!isTargetElement(e)) return;

  if (!position) {
    reset();
    return;
  }

  const distance = calculateDistance(position, { x: e.pageX, y: e.pageY });
  if (distance > WIGGLE_THRESHOLD) {
    reset();
    return;
  }

  upEventType = e.type;

  clearTimeout(timer!);
  timer = window.setTimeout(reset, DELAY);

  taps++;
  if (taps === TAPS_COUNT) {
    onSuccess();
    reset();
  }
};

export {
  up,
  down,
};
